import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { AuthService } from '../services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(
    private router: Router,
    private authService: AuthService
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    console.log('AuthGuard: Checking access to', state.url);
    
    return this.authService.isLoggedIn().pipe(
      take(1),
      map(isLoggedIn => {
        console.log('AuthGuard: isLoggedIn =', isLoggedIn);
        
        if (isLoggedIn) {
          console.log('AuthGuard: Access granted');
          return true;
        } else {
          console.log('AuthGuard: Access denied, redirecting to login');
          // Store the attempted URL for redirecting after login
          this.authService.setRedirectUrl(state.url);
          this.router.navigate(['/login']);
          return false;
        }
      })
    );
  }
}
